import ButtonFunction from "./shared/ButtonFunction";
import GeneralContext from "../context/GeneralContext";
import { useContext } from "react";
import { fetchBody } from '../utils/fetch'

function TableRequest({data = defaultData, userType = defaultUserType}) {

    const {
        changeModalTitle,
        changeModalContent,
        changeModalText,
        changeModalType,
        changeModalFunction1,
        changeModalFunction2,
        changeCurrentMenu,
        changeUserMenu
    } = useContext(GeneralContext);

    const modal = document.getElementById("myModal");
    const openModal = (data) => {
        changeModalFunction1(() => async () => {
            const fetchData = {
                requestId: data[3],
                comment: document.getElementById('commentText').value,
                resolution: 'Aprobado'
            };
            if (fetchData.comment.length < 11) {
                alert('Por favor escriba una razón de más de 10 caracteres');
            } else {
                const response = await fetchBody('requests/', 'PUT', fetchData);
                if (response.success) {
                    changeCurrentMenu('manage-requests');
                    document.getElementById('commentText').value = '';
                    modal.style.display = "none";
                } else {
                    changeModalTitle('Error al intentar desactivar usuario');
                    changeModalText(response.reason);
                    changeModalType('alert');
                    modal.style.display = "block";
                }
            }
        });
        changeModalFunction2(() => async () => {
            const fetchData = {
                requestId: data[3],
                comment: document.getElementById('commentText').value,
                resolution: 'Rechazado'
            };
            if (fetchData.comment.length < 11) {
                alert('Por favor escriba una razón de más de 10 caracteres');
            } else {
                const response = await fetchBody('requests/', 'PUT', fetchData);
                if (response.success) {
                    changeCurrentMenu('manage-requests');
                    modal.style.display = "none";
                } else {
                    changeModalTitle('Error al intentar desactivar usuario');
                    changeModalText(response.reason);
                    changeModalType('alert');
                    modal.style.display = "block";
                }
            }
        });
        changeModalTitle('Solicitud Pendiente');
        changeModalContent([{id: 0, text: 'Solicitante: ' + data[0]}, {id: 1, text: 'Beneficio solicitado: ' + data[1]}, {id: 2, text: 'Fecha deseada: ' + data[2]}]);
        changeModalType('request');
        modal.style.display = "block";
    }

    const cancelRequest = (id) => {
        changeModalFunction1(() => async () => {
            const fetchData = {
                requestId: id
            }
            const response = await fetchBody('requests/', 'DELETE', fetchData);
            if (response.success) {
                changeUserMenu('history');
                modal.style.display = "none";
            } else {
                changeModalTitle('Error al intentar cancelar la solicitud');
                changeModalText(response.reason);
                changeModalType('alert');
                modal.style.display = "block";
            }
        })
        changeModalTitle('Cancelando solicitud');
        changeModalType('confirm');
        modal.style.display = "block";
    }

  return (
    <>
    <div className="tableContainer">
        <div className="row">
            <div><label><strong>{data.userName}</strong></label></div>
        </div>
        <div className="tripleColumn">
            <div className="row"><label><strong>Beneficio solicitado:</strong> {data.title}</label></div>
            <div className="row"><label><strong>Valor:</strong> {data.value}</label></div>
            <div className="row"><label><strong>Fecha de creación:</strong> {data.request_date}</label></div>
        </div>
        <div className="row">
            <label><strong>Fecha solicitada</strong>: {data.expected_date}</label>
        </div>
        <div className="row">
            <label><strong>Justificación de solicitud</strong></label>
            <br />
            <p>{data.request_comments}</p>
        </div>
        {data.status !== 'pending' ?
            <>
                <div className="tripleColumn">
                    <div className="row"><label><strong>Decisión:</strong> {data.status}</label></div>
                    <div className="row"><label><strong>Autor:</strong> {data.status_change_author}</label></div>
                    <div className="row"><label><strong>Fecha de aprobación:</strong> {data.status_change_date}</label></div>
                </div>
                <div className="row">
                    <label><strong>Comentario de decisión</strong></label>
                    <br />
                    <p>{data.status_change_comments}</p>
                </div>
            </>
            : <></>
        }
    </div>
    {data.status !== 'pending' ?
        <></> :
        <>
        {userType === 'admin' ? 
        <>
            <br />
            
            <ButtonFunction
            buttonClass="adminButton"
            buttonFunction={openModal}
            buttonArguments={[data.userName, data.title, data.expected_date, data.id]}>
                Decidir
            </ButtonFunction>
        </>
        :
        <>
            <br />
            
            <ButtonFunction
            buttonClass="cancelButton"
            buttonFunction={cancelRequest}
            buttonArguments={data.id}>
                Cancelar Solicitud
            </ButtonFunction>
        </>
        }
        </>
    }
    <br />
    <br />
    <br />
    </>
  )
}

const defaultData = {
    userName: 'Fulano de Tal',
    title: 'Vacaciones a Fhloston Paradise',
    value: '365',
    request_date: '15/03/2024',
    request_comments: 'Leeloo Multipase',
    status: 'pending',
    status_change_author: 'Menganito',
    status_change_date: '18/03/2024',
    status_change_comments: 'Porque esa es la vida'
};

const defaultUserType = 'admin';

export default TableRequest